import { render, staticRenderFns } from "./FreeboardDetails.vue?vue&type=template&id=06813ce8"
import script from "./FreeboardDetails.vue?vue&type=script&lang=js"
export * from "./FreeboardDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports